import React, { useEffect } from 'react'
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { useDispatch } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom'
import { checkToken, openSidebar } from '../Redux/Dashboard/DashboardSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faBars, faBuildingColumns } from '@fortawesome/free-solid-svg-icons'
import '../Style/Style.css'

function Navb() {

  const dispatch = useDispatch()
  const token = localStorage.getItem("token")

  const navigate = useNavigate()

  useEffect(() => {
    if (token) {
      dispatch(checkToken(true))

    } else {
      dispatch(checkToken(false))
    }
  }, [token])

  return (
    <Navbar expand="lg" className=' bg-dark'>
      <Container fluid className=''>
        <button className='navcontactbtn' onClick={() => dispatch(openSidebar(true))}><FontAwesomeIcon className='text-white' style={{ height: "30px" }} icon={faBars} /></button>

        {/* <Navbar.Toggle aria-controls="navbarScroll" /> */}
        {/* <Navbar.Collapse className='' id="navbarScroll"> */}
          <Nav
            className="navbg me-auto my-2 mx-auto"
            style={{ maxHeight: '100px' }}
            navbarScroll
          >
            <FontAwesomeIcon className='text-white me-4' style={{ height: "30px" }} icon={faBuildingColumns} />

            <NavLink
              to="/home"
              className={({ isActive }) => isActive ? 'navabout active' : 'navabout'}
            >
              Dev Judicial Academy
            </NavLink>

          </Nav>
          <NavDropdown className="text-white" title={<FontAwesomeIcon className='text-white' style={{ height: "30px" }} icon={faUser} />} id="navbarScrollingDropdown">
            <NavDropdown.Item as="div" className="text-center">
              <Button
                variant="outline-primary"
                className="profile-button-custom"
                onClick={() => navigate("/profile")}
              >
                Profile
              </Button>
            </NavDropdown.Item>


            <NavDropdown.Divider />

            <NavDropdown.Item className="text-center">
              <Button
                variant="outline-danger"
                className="logout-button-custom"
                onClick={() => {
                  localStorage.clear();
                  navigate("/");
                  dispatch(checkToken(false));
                }}
              >
                Logout
              </Button>
            </NavDropdown.Item>

          </NavDropdown>

        {/* </Navbar.Collapse> */}

      </Container>
    </Navbar>

  );
}


export default Navb;